import client from '../client'

export default async function getDictViewCnt(ids: string, objDictViewCnt: any) {
  const response = await client.post<any>(`/api/search`, {
    ids: ids,
    requestApi: 'getDictViewCntArrUri',
  })

  // 좀 복잡해서 그냥 복붙함
  if (response.data.hasOwnProperty('result')) {
    var resultObjectMap = response.data.result.map
    if (resultObjectMap.hasOwnProperty('RESP_RESULT')) {
      var RESP_RESULT = resultObjectMap.RESP_RESULT.map
      if (RESP_RESULT.hasOwnProperty('DICTVIEW')) {
        var arrDictView = RESP_RESULT.DICTVIEW.myArrayList
        if (arrDictView.length > 0) {
          for (var iCnt = 0; iCnt < arrDictView.length; iCnt++) {
            var tmpMap = arrDictView[iCnt].map
            objDictViewCnt[tmpMap.DICT_DVSN_CD + '_' + tmpMap.DICT_UNIQ_ID] = tmpMap.COUNT
          }
        }
      }
    }
  }
}

// function getAjaxDictViewCnt(ids) {

// 	var url = "/common/api/search";
// 	var param = {
// 		'ids' : ids
// 		, 'requestApi' : 'getDictViewCntArrUri'
// 	}
// 	$.common_api(url, "post", JSON.stringify(param), fn_getDictViewCnt);
